/**
 * Parses and removes the data from the dom
 * Data lives in a <code> tag on the PHP side.
 * Data is Base_64 encoded and written to plain text.
 * This function pulls that text, decodes it and sets it,
 * then it removes that dom element.
 *
 * @returns {Object}
 */
export default function getSSRData() {
  // Get the text from the code tag in the DOM
  const ssrDataElement = document.querySelector<HTMLElement>('#ssr-data');

  // if #ssr-data doesn't exist return nothing
  if (!ssrDataElement) {
    return {
      user: {},
    };
  }

  const text = ssrDataElement.innerText;

  // Return early if the element has no content to avoid JSON.parse throwing
  // SyntaxError: Unexpected end of JSON input on empty strings
  if (!text) {
    return {
      user: {},
    };
  }

  // base 64 decode text
  const decodedText = atob(text);

  // TODO: Remove the element from the DOM, stopped removal because browser navigation keeps it removed, when it shouldn't be
  // ssrDataElement.parentNode.removeChild(ssrDataElement);

  // Parse the data and return
  return JSON.parse(decodedText);
}
